<template>
  <div>
    <div 
      @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input 
      type="file"
      accept="application/pdf"
      ref="file"
      :name="filename"
      v-on:change="changeFile($event.target.files)"
      style="display:none">

    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar 
              color="red accent-2" 
              size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-card-text 
                class="caption white--text pa-0">
                {{ message.error }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { pdfUploadUrl, getCdnStoredPath } from '@/utils/cdn'

  export default {
    name: 'upload-document',
    data: () => ({
      dialog: false,
      filename: 'file',
      message: {
        success: '',
        error: ''
      },
      process: {
        form: false
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      changeFile (file) {
        let document = file[0]
        if (file.length > 0) {
          if (document.type != 'application/pdf') {
            this.dialog = true
            this.message.error = 'Silahkan pilih dokumen dengan format .pdf'
          } else if (document.size > 5242880) {
            this.dialog = true
            this.message.error = 'Maksimal dokumen 5MB'
          } else {
            // let formData = new FormData()
            //   formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
            //   formData.append('client-key', 'ppid459584a2be25dd8ae6bb403c3959')
            //   formData.append('files[]', document)
            //   formData.append('user_id', this.$store.state.user.id)

            // this.process.form = true
            // this.$emit('input', {
            //   process: this.process.form
            // })

            // fetch(`${process.env.VUE_APP_API_CDN}document`, {
            //   method: 'POST',
            //   body: formData
            // })
            // .then(res => res.json())
            // .then(response => {
            //   this.process.form = false

            //   this.$emit('input', {
            //     id: response.data[0].id,
            //     type: response.data[0].type,
            //     data: response.data[0].data,
            //     process: this.process.form
            //   })
            // })
            let formData = new FormData()
                formData.append('key', 'file')
                formData.append('file', document)
                formData.append('client_name', 'sifasum')
                formData.append('visibility', 'private')

            this.process.form = true
            this.$emit('input', {
              process: this.process.form
            })

            fetch(pdfUploadUrl, {
              method: 'POST',
              body: formData
            })
            .then(res => res.json())
            .then(response => {
              this.process.form = false

            this.$emit('input', {
                filename: response.data.filename,
                fullpath: getCdnStoredPath(response),
                process : this.process.form
              })
            })
          }
        }
      }
    }
  }
</script>